import React, { useState, useEffect, useRef } from 'react';
import _ from 'lodash';
import Pagination from '../components/common/Pagination';
import UserLoader from '../components/common/Squeleton';
import { allService } from '../services';
import { useTranslation } from 'react-i18next';
import toast, { Toaster } from 'react-hot-toast';
import NewTransaction from '../components/users/newtransaction';
import Faq from '../components/users/faq';
import { useHistory } from 'react-router-dom';
import { logOut, removeToken, deleteuser, addTransac } from '../actions';
import { useDispatch, useSelector } from 'react-redux';
import { fetchWrapper } from '../fetchWrapper';
import $ from 'jquery';

export default function Users() {
  //
  const user = useSelector((state) => state.user);
  const token = useSelector((state) => state.token);
  const isAuthenticated = useSelector((state) => state.connection);
  const [count, setCount] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [showNewTransaction, setShowNewTransaction] = useState(false);
  const [showFaq, setShowFaq] = useState(false);
  const [bundlesPopup, showBundlesPopup] = useState(false);
  const [downloadPopup, showDownloadPopup] = useState(false);
  const [showForfait, setShowForfait] = useState(true);
  const [showMobile, setShowMobile] = useState(false);
  const [showTransaction, setShowTransaction] = useState(false);
  const [allTransac, setTransac] = useState([]);
  const [bundles, setBundle] = useState([]);
  const [operators, setOperator] = useState([]);
  const [paymentMethods, setPaymentMethod] = useState([]);
  const [transacData, settransacData] = useState({
    operationType: 'TOPUP',
    operatorToCredit: '',
    phoneToCredit: '',
    transacAmount: '',
    bundleChoice: '',
    paymentMethod: '',
    paymentMethodImg: '',
    payerPhone: '',
  });
  const [error, setError] = useState({
    phoneToCreditErr: '',
    transacAmountErr: '',
    payerPhoneErr: '',
    transacErr: '',
  });
  const [isDisable, setDisable] = useState(true);
  const [loadTransac, setLoadTransac] = useState(false);
  const [transacSuccessMsg, displayTransacSuccessMsg] = useState(false);
  const [filteredAllData, setFilteredData] = useState([]);
  const [paginatedData, setPaginatedData] = useState([]);
  const [pages, setPages] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const { t, i18n } = useTranslation();
  const [lang, setLang] = useState('Fr');
  const history = useHistory();
  const dispatch = useDispatch();
  const [userLoader, displayUserLoader] = useState(true);
  const [pageErr, displayPageErr] = useState(false);
  const [filteredAllData1, setFilteredData1] = useState([]);
  const [clear, setclear] = useState('');
  const [collectbundle, setcollectbundle] = useState('');
  const TransactionCount = [
    { label: `10  ${t('transaction')}`, value: 10 },
    { label: `50  ${t('transactions')}`, value: 50 },
    { label: `100  ${t('transactions')}`, value: 100 },
    { label: `200  ${t('transactions')}`, value: 200 },
    { label: ` ${t('Show_all')}`, value: 'all' },
  ];
  const TransactionStatus = [
    { label: t('Completed'), value: 'COMPLETED' },
    { label: t('In_progress'), value: 'PENDING' },
    { label: t('Failed_trans'), value: 'FAILED' },
    { label: t('Show_all'), value: 'all' },
  ];
  //for all operators (MTN,ORANGE and CAMTEL)
  const operatorStatus = [
    { label: 'ORANGE', value: 'ORANGE' },
    { label: 'MTN', value: 'MTN' },
    { label: 'CAMTEL', value: 'CAMTEL' },
    { label: t('Show_all'), value: 'all' },
  ];

  // function use to naviagte a user
  const navigation = (nav) => {
    history.push({
      pathname: nav,
    });
  };

  // Method to show / hide the modal
  const handleToggleFaq = () => {
    setShowFaq(true);
  };

  //
  const handleShowMobile = () => {
    if (!showMobile) {
      settransacData({
        operationType: 'TOPUP',
        operatorToCredit: operators[0].name,
        phoneToCredit: '',
        transacAmount: '',
        bundleChoice: '',
        paymentMethod: paymentMethods[0].code,
        paymentMethodImg: paymentMethods[0].logo,
        payerPhone: '',
      });
      setError({
        phoneToCreditErr: '',
        payerPhoneErr: '',
        transacAmountErr: '',
        transacErr: '',
      });
    }
    setShowMobile(true);
    setShowForfait(false);
  };

  //
  const handleShowForfait = () => {
    if (!showForfait) {
      settransacData({
        operationType: 'BUNDLE',
        operatorToCredit: operators[0].name,
        phoneToCredit: '',
        transacAmount: '',
        bundleChoice: '',
        paymentMethod: paymentMethods[0].code,
        paymentMethodImg: paymentMethods[0].logo,
        payerPhone: '',
      });
      setError({
        phoneToCreditErr: '',
        payerPhoneErr: '',
        transacAmountErr: '',
        transacErr: '',
      });
    }
    setShowMobile(false);
    setShowForfait(true);
  };

  //Function use to update paginate data when data array has been updated
  const updatePagination = (data) => {
    setFilteredData(data);
    setPaginatedData(_(data).slice(0).take(pageSize).value());
    setPages(_.range(1, Math.ceil(data.length / pageSize) + 1));
  };

  //Method use to research by status
  const handleStatus = (param) => {
    const f = filteredAllData.filter((d) => {
      if (param !== 'all' && d.status === param) return d;
      if (param === 'all') return d;
    });
    setPaginatedData(_(f).slice(0).take(pageSize).value());
    setPages(_.range(1, Math.ceil(f.length / pageSize) + 1));
    setCurrentPage(1);
    setCount(f.length);
    setclear('');
  };

  //Method use to research array by payer_number , type, uuid, type and receiver_phone
  const handleFilter = (e) => {
    const f = filteredAllData.filter((d) => {
      if (e.target.value === '') return d;
      if (
        d.payer_number
          .toLowerCase()
          .trim()
          .includes(e.target.value.toLowerCase().trim())
      )
        return d;
      if (
        d.type
          .toLowerCase()
          .trim()
          .includes(e.target.value.toLowerCase().trim())
      )
        return d;
      if (
        d.receiver_number
          .toLowerCase()
          .trim()
          .includes(e.target.value.toLowerCase().trim())
      )
        return d;
      if (
        d.uuid
          .toLowerCase()
          .trim()
          .includes(e.target.value.toLowerCase().trim())
      )
        return d;
    });
    setPaginatedData(_(f).slice(0).take(pageSize).value());
    setPages(_.range(1, Math.ceil(f.length / pageSize) + 1));
    setCurrentPage(1);
    setCount(f.length);
    setclear(e.target.value);
  };

  //Method use to research by number users
  const handleNumberFilter = (param) => {
    let count;
    if (param === 'all') {
      count = filteredAllData.length;
    } else {
      count = param;
    }

    setPaginatedData(_(filteredAllData).slice(0).take(count).value());
    setPages(_.range(1, Math.ceil(filteredAllData.length / count) + 1));
    setPageSize(param);
    setCurrentPage(1);
    setCount(filteredAllData.length);
    setclear('');
  };

  //Method use to go to the next navigate page
  function goToNextPage() {
    setCurrentPage((page) => page + 1);
    pagination(currentPage + 1);
  }

  //Method use to go to the previous navigate page
  function goToPreviousPage() {
    setCurrentPage((page) => page - 1);
    pagination(currentPage - 1);
  }

  //Function use to add new item to data state
  const addItemToState = (item) => {
    var updatedList = [...allTransac];
    updatedList.unshift(item);
    setTransac(updatedList);
    updatePagination(updatedList);
    setCount(updatedList.length);
  };

  //Function use to update item state to the data array
  const updateState = (item) => {
    var userList = [...allTransac];
    const newArray = userList.map((user) => {
      if (user.id === item.id) {
        user = item;
      }
      return user;
    });
    setTransac(newArray);
    updatePagination(newArray);
  };

  //Method use to set pagination data
  const pagination = (number) => {
    setCurrentPage(number);
    const startIndex = (number - 1) * pageSize;
    const paginateD = _(filteredAllData)
      .slice(startIndex)
      .take(pageSize)
      .value();
    setPaginatedData(paginateD);
  };

  const handleFilter1 = (e) => {
    const f = filteredAllData1.filter((d) => {
      if (e.target.value === '') return d;
      if (
        d.code
          .toLowerCase()
          .trim()
          .includes(e.target.value.toLowerCase().trim())
      )
        return d;
      if (
        d.operator
          .toLowerCase()
          .trim()
          .includes(e.target.value.toLowerCase().trim())
      )
        return d;
      if (
        d.description
          .toLowerCase()
          .trim()
          .includes(e.target.value.toLowerCase().trim())
      )
        return d;
    });
    setBundle(_(f).slice(0).take(pageSize).value());
  };

  //Method use to research by status
  const handleStatus1 = (param) => {
    const f = filteredAllData1.filter((d) => {
      if (param !== 'all' && d.operator === param) return d;
      if (param === 'all') return d;
    });
    setBundle(_(f).slice(0).take(pageSize).value());
  };

  // functions to perform side effects
  useEffect(() => {
    displayUserLoader(true);
    Promise.all([
      allService.getAllWithoutToken('operators/list/'),
      allService.getAllWithoutToken('bundles/list/'),
      allService.getAllWithoutToken('payment-processors/list'),
    ])
      .then(([operator, bundle, paymentMethod], failure) => {
        setBundle(bundle);
        setcollectbundle(bundle);
        setFilteredData1(bundle);
        setOperator(operator);
        setPaymentMethod(paymentMethod);
        settransacData({
          ...transacData,
          operatorToCredit: operator[0].name,
          paymentMethod: paymentMethod[0].code,
          paymentMethodImg: paymentMethod[0].logo,
        });

        displayUserLoader(false);

        if (operator.length === 0 || paymentMethod.length === 0) {
          displayPageErr(true);
        }
      })
      .catch((e) => {
        //console.log(e)
        displayUserLoader(false);
        displayPageErr(true);
      });
  }, []);

  const verifyFormTransac = (e) => {
    let disabled = true;
    if (
      !allService.empty(transacData.operationType) &&
      !allService.empty(transacData.transacAmount) &&
      transacData.transacAmount >=
        operators.find((e) => e.name == transacData.operatorToCredit)
          .min_amount &&
      transacData.transacAmount <=
        operators.find((e) => e.name == transacData.operatorToCredit)
          .max_amount &&
      !allService.empty(transacData.operatorToCredit) &&
      allService.validateOperatorPhone(
        transacData.operatorToCredit,
        transacData.phoneToCredit,
      ) &&
      !allService.empty(transacData.phoneToCredit) &&
      allService.validateOperatorPhone(
        transacData.paymentMethod,
        transacData.payerPhone,
      ) &&
      !allService.empty(transacData.payerPhone) &&
      !allService.empty(transacData.paymentMethod) &&
      (transacData.operationType === 'TOPUP' ||
        (transacData.operationType === 'BUNDLE' &&
          !allService.empty(transacData.bundleChoice)))
    ) {
      disabled = false;
    }
    setDisable(disabled);
  };

  useEffect(() => {
    verifyFormTransac();
    setError({
      ...Error,
      phoneToCreditErr:
        !allService.empty(transacData.phoneToCredit) &&
        !allService.validateOperatorPhone(
          transacData.operatorToCredit,
          transacData.phoneToCredit,
        )
          ? t('Incorrect_number') + ` (${transacData.operatorToCredit})`
          : '',
      payerPhoneErr:
        !allService.empty(transacData.payerPhone) &&
        !allService.empty(transacData.paymentMethod) &&
        !allService.validateOperatorPhone(
          transacData.paymentMethod,
          transacData.payerPhone,
        )
          ? t('Incorrect_number') + ` (${transacData.paymentMethod})`
          : '',
      transacAmountErr:
        !allService.empty(transacData.transacAmount) &&
        (transacData.transacAmount <
        operators.find((e) => e.name == transacData.operatorToCredit).min_amount
          ? `${t('The_minimum_amount_is')} ${allService.numberWithCommas(
              operators.find((e) => e.name == transacData.operatorToCredit)
                .min_amount,
            )} Fcfa`
          : '' ||
            transacData.transacAmount >
              operators.find((e) => e.name == transacData.operatorToCredit)
                .max_amount
          ? `${t('The_maximum_amount_is')} ${allService.numberWithCommas(
              operators.find((e) => e.name == transacData.operatorToCredit)
                .max_amount,
            )} Fcfa`
          : ''),
    });
  }, [transacData]);

  //Function to use to handle language choice
  const changeLanguageHandler = (l) => {
    i18n.changeLanguage(l.toLowerCase());
    setLang(l);
  };

  const handleSelectBundle = (bundle) => {
    settransacData({
      ...transacData,
      bundleChoice: bundle,
      transacAmount: isNaN(parseInt(bundle.price)) ? 0 : parseInt(bundle.price),
    });
  };

  const handleChangePhoneToCredit = (e) => {
    settransacData({ ...transacData, phoneToCredit: e.target.value });
  };

  const handleChangepayerPhone = (e) => {
    settransacData({ ...transacData, payerPhone: e.target.value });
  };

  const handleChangeTransacAmount = (e) => {
    '';
    settransacData({ ...transacData, transacAmount: e.target.value });
  };

  const handleSelectOperatorToCredit = (operator) => {
    settransacData({ ...transacData, operatorToCredit: operator });
  };

  const handleSelectPaymentMethod = (paymentMethod, paymentMethodImg) => {
    settransacData({
      ...transacData,
      paymentMethod: paymentMethod,
      paymentMethodImg: paymentMethodImg,
      payerPhone: '',
    });
  };

  const saveTransacData = () => {
    const dataToStore = {
      payer_number: transacData.payerPhone,
      payer_network: transacData.paymentMethod,
      amount: transacData.transacAmount,
      receiver_number: transacData.phoneToCredit,
      receiver_network: transacData.operatorToCredit,
      type: transacData.operationType,
      bundle_id: !allService.empty(transacData.bundleChoice)
        ? transacData.bundleChoice.id
        : null,
      bundle_name: !allService.empty(transacData.bundleChoice)
        ? transacData.bundleChoice.name
        : '',
    };
    createTransac(dataToStore);
  };

  function createTransac(data) {
    setLoadTransac(true);
    setError({ ...error, transacErr: '' });
    setShowNewTransaction(true);
    allService
      .create(data, 'credit-transfer/create', token)
      .then((d) => {
        addItemToState(d.transfer);
        dispatch(addTransac(d));
        setShowNewTransaction(false);
        if (isAuthenticated) {
          setShowTransaction(true);
          toast.success(t('Operation_successfuly_completed'), {
            style: {
              padding: '16px',
              color: '#fff',
              background: '#02274a',
              borderRadius: '10px',
            },
            iconTheme: {
              primary: '#229954',
              secondary: '#FFFAEE',
            },
          });
        } else {
          if (d.success === true) {
            displayTransacSuccessMsg(true);
          } else {
            setLoadTransac(false);
            setShowNewTransaction(false);
            setError({ ...error, transacErr: t('A_server_error') });
          }
        }
      })
      .catch((e) => {
        setLoadTransac(false);
        setShowNewTransaction(false);
        setError({ ...error, transacErr: t('A_server_error') });
      });
  }

  //Method use to get all data from server
  function getData(isRefreshAction) {
    //displayUserLoader(true);

    allService
      .getAll('transactions/list/mine', token)
      .then((d) => {
        setTransac(d);
        setFilteredData(d);
        setCount(d.length);
        //displayuserTableLoader(false);
        setPaginatedData(_(d).slice(0).take(pageSize).value());
        setPages(_.range(1, Math.ceil(d.length / pageSize) + 1));
        //displayUserLoader(false);
      })
      .catch((e) => {
        /*toast.error(t("Failed_to_connect"), {
            style: {
                padding: '16px',
                color: '#fff',
                borderRadius: '10px',
                background: '#02274a',
            },
            iconTheme: {
                primary: '#FF0033',
                secondary: '#FFFAEE',
            },
        }, {
            duration: 10000
        });*/
      });
  }

  const disconnect = () => {
    dispatch(logOut());
    dispatch(removeToken());
    dispatch(deleteuser());
    history.push('/login');
  };

  // functions to perform side effects
  useEffect(() => {
    getData(false);
  }, []);

  useEffect(() => {
    if (bundlesPopup) {
      $('.modal-bundles').fadeIn('fast');
    } else {
      $('.modal-bundles').fadeOut('fast');
    }

    if (downloadPopup) {
      $('.modal-download').fadeIn('fast');
    } else {
      $('.modal-download').fadeOut('fast');
    }
  }, [bundlesPopup, downloadPopup]);

  const avortTransac = () => {
    fetchWrapper.abortTransac();
    setShowNewTransaction(false);
  };
  //Method use to research array by payer_number , type, uuid, type and receiver_phone
  const handleFilter2 = (e) => {
    const f = collectbundle.filter((d) => {
      if (e.target.value === '') return d;
      if (
        d.name
          .toLowerCase()
          .trim()
          .includes(e.target.value.toLowerCase().trim())
      )
        return d;
      if (
        d.code
          .toLowerCase()
          .trim()
          .includes(e.target.value.toLowerCase().trim())
      )
        return d;
      if (
        d.operator
          .toLowerCase()
          .trim()
          .includes(e.target.value.toLowerCase().trim())
      )
        return d;

      //console.log(d)
    });
    setBundle(_(f).slice(0).take(pageSize).value());
  };

  const creditImageRef = useRef();
  const dataImageRef = useRef();

  return (
    <>
      <div
        className="w-100"
        style={{ height: 'auto', position: 'fixed', zIndex: 2000 }}
      >
        <div
          className="text-center elipsis pl-2 pr-2"
          style={{ background: '#C69E44', color: '#fff' }}
        >
          <span className="ads-txt">
            <span>
              <strong>No 1</strong>
            </span>
            <span className="font-weight-light">
              &nbsp;{t('Number_refill')}
            </span>
          </span>
        </div>

        <div
          style={{
            height: '70px',
            background: '#000a2b',
            color: '#fff',
            padding: '0 20px',
          }}
        >
          <div className="fl-l logo" style={{ position: 'relative' }}>
            <img className="img-fluid" src="assets/img/glo-pay.png" />
          </div>
          <div
            className="fl-r cursor"
            style={{
              display: 'inline-block',
              verticalAlign: 'bottom',
              fontSize: '0.795em',
              position: 'relative',
              top: '16px',
            }}
          >
            <a
              data-toggle="dropdown"
              className="btn btn-primary option rounded-circle"
              role="button"
              href="#"
              style={{
                display: 'inline-block',
                padding: '1px 5px',
                paddingTop: '5px',
                fontSize: '0.985em',
                boxShadow: 'none',
                position: 'relative',
              }}
            >
              <i className="material-icons">person</i>
            </a>
            <div
              className="d-none d-md-inline-block text-left"
              style={{
                marginLeft: '6px',
                paddingRight: '10px',
                verticalAlign: 'top',
                position: 'relative',
                top: '-2px',
              }}
              data-toggle="dropdown"
            >
              {!allService.empty(user) && !allService.empty(user.name) && (
                <div>
                  <h6
                    className="fw-400 mb-0 d-inline-block mr-2"
                    style={{ fontSize: '0.965em' }}
                  >
                    {user.name.split(' ')[0]}&nbsp;
                    <strong>
                      {user.name.split('').length > 1
                        ? user.name.split(' ')[1]
                        : ''}
                    </strong>
                  </h6>
                  <i
                    className="icon-arrow-down cursor"
                    style={{ fontSize: '0.835em', position: 'relative' }}
                  ></i>
                  <span
                    className="d-block pr"
                    style={{ fontSize: '0.765em', top: '-7px' }}
                  >
                    {allService.chunk(user.telephone, 3, ' ')}
                  </span>
                </div>
              )}
            </div>
            <div
              className="dropdown-menu drop-lang"
              role="menu"
              style={{
                minWidth: '190px',
                fontSize: '1.26em',
                marginTop: '5px',
                marginRight: '18px',
              }}
            >
              {!allService.empty(user) && !allService.empty(user.name) && (
                <h6
                  className="fw-400 pr mb-0 d-md-none"
                  style={{ left: '15px', fontSize: '0.965em' }}
                >
                  {user.name.split(' ')[0]}
                  <strong>
                    {user.name.split('').length > 1
                      ? user.name.split(' ')[1]
                      : ''}
                  </strong>
                </h6>
              )}
              {!allService.empty(user) && !allService.empty(user.telephone) && (
                <span
                  className="d-block pr d-md-none"
                  style={{ fontSize: '0.665em', top: '-4px', left: '15px' }}
                >
                  {allService.chunk(user.telephone, 3, ' ')}
                </span>
              )}

              {!isAuthenticated && (
                <a onClick={() => navigation('/login')}>
                  <i
                    className="material-icons pr menu-i mr-1"
                    style={{ top: '2.9px', fontSize: '1.4em' }}
                  >
                    lock_open
                  </i>
                  &nbsp;
                  <span className="lang" keyword="my-account">
                    {t('login')}
                  </span>
                </a>
              )}

              <a onClick={() => setShowTransaction(true)} className="translate">
                <i
                  className="material-icons pr menu-i mr-1"
                  style={{ top: '2.8px', fontSize: '1.2em' }}
                >
                  featured_play_list
                </i>
                &nbsp;
                <span className="lang" keyword="my-account">
                  {t('My_transactions')}
                </span>
              </a>

              <a onClick={() => handleToggleFaq(true)} className="d-sm-none">
                <i
                  className="material-icons pr menu-i mr-1"
                  style={{ top: '2.8px', fontSize: '1.3em' }}
                >
                  help
                </i>
                &nbsp;
                <span className="lang" keyword="my-account">
                  FAQ
                </span>
              </a>
              {isAuthenticated && (
                <a onClick={() => disconnect()}>
                  <i
                    className="material-icons pr menu-i mr-1"
                    style={{ top: '3.9px', fontSize: '1.4em', padding: '1px' }}
                  >
                    power_settings_new
                  </i>
                  &nbsp;
                  <span className="lang" keyword="disconnect">
                    {t('Disconnect')}
                  </span>
                </a>
              )}
            </div>
          </div>
          <div
            onClick={() => showDownloadPopup(!downloadPopup)}
            className="fl-r mr-2"
            style={{
              display: 'inline-block',
              verticalAlign: 'bottom',
              fontSize: '0.795em',
              position: 'relative',
              top: '16px',
            }}
          >
            <a
              className="btn btn-primary option rounded-circle faq"
              role="button"
              href="#"
              style={{
                display: 'inline-block',
                padding: '1px 5px',
                paddingTop: '5px',
                fontSize: '0.985em',
                boxShadow: 'none',
                position: 'relative',
              }}
              title="Download"
            >
              <i className="material-icons">file_download</i>
            </a>
          </div>
          <div
            onClick={() => handleToggleFaq()}
            className="fl-r mr-2 d-none d-sm-block"
            style={{
              display: 'inline-block',
              verticalAlign: 'bottom',
              fontSize: '0.795em',
              position: 'relative',
              top: '16px',
            }}
          >
            <a
              className="btn btn-primary option rounded-circle faq"
              role="button"
              href="#"
              style={{
                display: 'inline-block',
                padding: '1px 5px',
                paddingTop: '5px',
                fontSize: '0.985em',
                boxShadow: 'none',
                position: 'relative',
              }}
              title="FAQ"
            >
              <i className="material-icons">help</i>
            </a>
          </div>
          <div
            className="d-none d-xs-block fl-r mr-2"
            style={{
              display: 'inline-block',
              verticalAlign: 'bottom',
              fontSize: '0.795em',
              position: 'relative',
              top: '16px',
            }}
          >
            <div
              style={{
                marginRight: '5px',
                display: 'inline-block',
                verticalAlign: 'middle',
              }}
            >
              <span className="lang" keyword="fr">
                {lang}
              </span>
            </div>
            <button
              className="btn btn-primary option rounded-circle"
              type="button"
              style={{
                display: 'inline-block',
                padding: '1px 5px',
                paddingTop: '5px',
                fontSize: '0.985em',
                boxShadow: 'none',
                position: 'relative',
              }}
              data-toggle="dropdown"
              title="Langue"
            >
              <i className="material-icons">language</i>
            </button>
            <div
              className="dropdown-menu drop-lang"
              role="menu"
              style={{
                marginRight: '16px',
                marginTop: '5px',
                fontSize: '1.26em',
              }}
            >
              <a
                onClick={() => changeLanguageHandler('Fr')}
                id="fr"
                className="translate"
                data-reload
              >
                <img
                  src="assets/img/france_96px.png"
                  style={{ width: '20px', position: 'relative', top: '-3px' }}
                />
                &nbsp;
                <span
                  className="lang"
                  keyword="french"
                  style={{ position: 'relative', top: '-2px' }}
                >
                  {t('french-lang')}
                </span>
                <br />
              </a>
              <a
                onClick={() => changeLanguageHandler('En')}
                id="en"
                className="translate"
              >
                <img
                  src="assets/img/great_britain_96px-1.png"
                  style={{ width: '20px', position: 'relative', top: '-3px' }}
                />
                &nbsp;
                <span
                  className="lang"
                  keyword="english"
                  style={{ position: 'relative', top: '-2px' }}
                >
                  {t('english-lang')}
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div style={{ height: '95px' }} />

      {userLoader && <UserLoader />}

      {!showTransaction && !userLoader && !pageErr && (
        <div
          className="row col-12 col-lg-7 col-xl-6 m-auto p-0"
          style={{ zIndex: 1 }}
        >
          <div className="col col-4 col-xl-4 pt-5 d-none d-lg-block">
            <h6 className="mb-4 fw-700 ">{t('What_do_you_want_to_buy')}</h6>

            <div
              onClick={() => handleShowForfait()}
              className={
                showForfait
                  ? 'op-choice selected d-block text-center mb-2 cursor bg-i'
                  : 'op-choice d-block text-center mb-2 cursor bg-i'
              }
              title="Forfaits mobiles"
            >
              <img
                src="assets/img/icons8_wifi_router_filled_125px.png"
                className="d-inline-block va-b mr-1"
                style={{ width: '20px' }}
              />
              <div
                className="d-inline-block va-m text-left"
                style={{ width: 'Calc(100% - 30px)' }}
              >
                <span
                  className="d-block elipsis"
                  style={{ fontSize: '0.865em' }}
                >
                  {t('Mobile_data')}
                </span>
              </div>
            </div>

            <div
              onClick={() => handleShowMobile()}
              className={
                showMobile
                  ? 'op-choice selected d-block text-center mb-2 cursor bg-i'
                  : 'op-choice d-block text-center mb-2 cursor bg-i'
              }
              title="Crédit téléphonique"
            >
              <img
                src="assets/img/icons8_phone_office_125px.png"
                className="d-inline-block va-b mr-1"
                style={{ width: '20px' }}
              />
              <div
                className="d-inline-block va-m text-left"
                style={{ width: 'Calc(100% - 30px)' }}
              >
                <span
                  className="d-block elipsis"
                  style={{ fontSize: '0.865em' }}
                >
                  {t('Telephone_credit')}
                </span>
              </div>
            </div>
          </div>

          <div className="col col-12 col-lg-8 col-xl-7 p-0">
            <div
              className="content text-left col-12 mt-0 mt-lg-4 pt-0 pt-lg-3"
              style={{ position: 'relative', zIndex: 2000 }}
            >
              <div className="container">
                <div className="row d-lg-none mb-2 mt-2">
                  <div
                    className="col col-6 p-0"
                    onClick={() => handleShowForfait()}
                  >
                    <div
                      className={
                        showForfait
                          ? 'op-choice selected d-block text-center mb-2 cursor'
                          : 'op-choice d-block text-center mb-2 cursor'
                      }
                      title="Forfaits mobiles"
                      style={{ padding: '15px 10px' }}
                    >
                      <img
                        src="assets/img/icons8_wifi_router_filled_125px.png"
                        className="d-inline-block va-b mr-1"
                        style={{ width: '20px' }}
                      />
                      <div
                        className="d-inline-block va-m text-left"
                        style={{ width: 'Calc(100% - 30px)' }}
                      >
                        <span
                          className="d-block elipsis"
                          style={{ fontSize: '0.965em' }}
                        >
                          {t('Mobile_data')}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div
                    className="col col-6 p-0 pr-1"
                    onClick={() => handleShowMobile()}
                  >
                    <div
                      className={
                        showMobile
                          ? 'op-choice selected d-block text-center mb-2 cursor'
                          : 'op-choice d-block text-center mb-2 cursor'
                      }
                      title="Crédit téléphonique"
                      style={{ padding: '15px 10px' }}
                    >
                      <img
                        src="assets/img/icons8_phone_office_125px.png"
                        className="d-inline-block va-b mr-1"
                        style={{ width: '20px' }}
                      />
                      <div
                        className="d-inline-block va-m text-left"
                        style={{ width: 'Calc(100% - 30px)' }}
                      >
                        <span
                          className="d-block elipsis"
                          style={{ fontSize: '0.965em' }}
                        >
                          {t('Telephone_credit')}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div id="main">
                  {showMobile && (
                    <form className="mb-5">
                      <h3 className="fw-800 title">
                        {t('Buy_telephone_credit')}
                      </h3>
                      <div className="mt-4 mb-4">
                        <h6
                          className="text-left"
                          style={{ fontWeight: 300, fontSize: '0.9rem' }}
                        >
                          {t('Number_to_be_credited')}
                        </h6>
                        <div className="mb-2">
                          <div
                            className="d-inline-block va-t open-list cursor"
                            style={{
                              backgroundColor: 'var(--input-background)',
                              paddingRight: '5px',
                              width: '77px',
                            }}
                          >
                            <div
                              className="d-inline-block"
                              style={{
                                width: '55px',
                                height: '55px',
                                padding: '5px',
                              }}
                            >
                              <img
                                className="img-fluid open-list op-selected d-inline-block"
                                src={
                                  operators.find(
                                    (e) =>
                                      e.name == transacData.operatorToCredit,
                                  ).image
                                }
                              />
                            </div>
                            <i
                              className="icon-arrow-down fl-r fw-600"
                              style={{
                                fontSize: '0.800em',
                                position: 'relative',
                                top: '23px',
                              }}
                            ></i>
                          </div>

                          <div
                            className="drop-lang option-list"
                            style={{ width: '255px', marginTop: '10px' }}
                          >
                            <h6 style={{ fontSize: '0.865em' }}>
                              {t('choice_of_Operator')}
                            </h6>
                            {operators.map((operator, i) => {
                              if (operator.can_topup === 1) {
                                return (
                                  <a
                                    key={i}
                                    href="#"
                                    onClick={() =>
                                      handleSelectOperatorToCredit(
                                        operator.name,
                                      )
                                    }
                                    className={`choice ${
                                      operator.name ===
                                      transacData.operatorToCredit
                                        ? 'choice-selected'
                                        : ''
                                    } mb-1 elipsis`}
                                  >
                                    <img
                                      src={operator.image}
                                      className="mr-2"
                                      style={{ width: '25px' }}
                                    />
                                    {operator.name}
                                  </a>
                                );
                              }
                            })}
                          </div>
                          <input
                            disabled
                            value={transacData.phoneToCredit}
                            onChange={(e) => handleChangePhoneToCredit(e)}
                            className="form-control form-with-logo d-inline-block"
                            type="number"
                            style={{
                              width: 'Calc(100% - 77px)',
                              border: 'none',
                            }}
                          />
                        </div>
                        {!allService.empty(error.phoneToCreditErr) && (
                          <span className="err">{error.phoneToCreditErr}</span>
                        )}
                      </div>
                      <div className="mb-4">
                        <h6
                          className="text-left"
                          style={{
                            fontWeight: 300,
                            fontSize: '0.9rem',
                            lineHeight: 1,
                          }}
                        >
                          {t('Amount_to_be_credited')} Fcfa
                        </h6>
                        <input
                          disabled
                          value={transacData.transacAmount}
                          onChange={(e) => handleChangeTransacAmount(e)}
                          className="form-control"
                          type="number"
                        />
                        {!allService.empty(error.transacAmountErr) && (
                          <span className="err">{error.transacAmountErr}</span>
                        )}
                      </div>
                      <div className="mb-4">
                        <h6
                          className="mb-0"
                          style={{
                            fontWeight: 300,
                            fontSize: '0.9rem',
                            lineHeight: 1,
                          }}
                        >
                          {t('payment_mode')}
                        </h6>
                        <span
                          className="font-weight-light"
                          style={{ fontSize: '0.8em' }}
                        >
                          {t('payment_is_secured_and_without_charges')}
                        </span>
                        {/*{<div className="form-row mt-1">
                      <div className="col">
                        <div onClick={() => handleSelectPaymentMethod("MTN", "assets/img/MOMO.jpg")} className="cursor payment-choice" style={{ background: 'rgb(237,188,10)', border: '3px solid transparent' }}><img className="img-fluid" src="assets/img/MOMO.jpg" style={{ width: '50px' }} /><span className="sr-only fl-r pr fw-700" style={{ top: '12px', right: '10px', color: '#fff' }}>MOMO</span></div>
                      </div>
                      <div className="col">
                        <div onClick={() => handleSelectPaymentMethod("ORANGE", "assets/img/OM.jpg")} className="cursor payment-choice" style={{ background: '#333', border: '3px solid transparent' }}><img className="img-fluid" src="assets/img/OM.jpg" style={{ width: '50px' }} /><span className="sr-only fl-r pr fw-600" style={{ top: '12px', right: '10px', color: '#fff' }}>OM</span></div>
                      </div>
                    </div>*/}
                        <div className="mt-2 mb-2">
                          <div
                            className="d-inline-block va-t open-list cursor"
                            style={{
                              backgroundColor: 'var(--input-background)',
                              paddingRight: '5px',
                              width: '77px',
                            }}
                          >
                            <div
                              className="d-inline-block"
                              style={{
                                width: '55px',
                                height: '55px',
                                padding: '5px',
                              }}
                            >
                              <img
                                className="img-fluid open-list op-selected d-inline-block"
                                src={
                                  paymentMethods.find(
                                    (e) => e.code === transacData.paymentMethod,
                                  ).logo
                                }
                              />
                            </div>
                            <i
                              className="icon-arrow-down fl-r fw-600"
                              style={{
                                fontSize: '0.800em',
                                position: 'relative',
                                top: '23px',
                              }}
                            ></i>
                          </div>
                          <div
                            className="drop-lang option-list"
                            style={{ width: '255px', marginTop: '10px' }}
                          >
                            <h6 style={{ fontSize: '0.865em' }}>
                              {t('choice_of_Operator')}
                            </h6>
                            {
                              /*paymentMethods.map((paymentMethod, i) => {
                            if (paymentMethod.can_topup === 1) {
                              return <a key={i} href="#" onClick={() => handleSelectOperatorToCredit(paymentMethod.name)} className={`choice ${paymentMethod.name === transacData.operatorToCredit ? "choice-selected" : ""} mb-1 elipsis`}>
                                <img src={paymentMethod.logo} className="mr-2" style={{ width: '25px' }} />{paymentMethod.name}
                              </a>
                            }
                          })*/
                              paymentMethods.map((paymentMethod, i) => {
                                return (
                                  <a
                                    key={i}
                                    href="#"
                                    onClick={() =>
                                      handleSelectPaymentMethod(
                                        paymentMethod.code,
                                        paymentMethod.logo,
                                      )
                                    }
                                    className={`choice ${
                                      paymentMethod.code ===
                                      transacData.paymentMethod
                                        ? 'choice-selected'
                                        : ''
                                    } mb-1 elipsis`}
                                  >
                                    <img
                                      src={paymentMethod.logo}
                                      className="mr-2"
                                      style={{ width: '25px' }}
                                    />
                                    {paymentMethod.name}
                                  </a>
                                );
                              })
                            }
                          </div>
                          <input
                            disabled
                            value={transacData.payerPhone}
                            onChange={(e) => handleChangepayerPhone(e)}
                            className="form-control form-with-logo d-inline-block"
                            type="number"
                            style={{
                              width: 'Calc(100% - 77px)',
                              border: 'none',
                            }}
                            placeholder={`Numéro ${
                              paymentMethods.find(
                                (e) => e.code === transacData.paymentMethod,
                              ).name
                            }`}
                          />
                        </div>
                        {!allService.empty(error.payerPhoneErr) && (
                          <span className="err">{error.payerPhoneErr}</span>
                        )}
                      </div>
                      {/*<div className="mb-4">
                    <h6 className="text-left" style={{ fontWeight: 300, fontSize: '0.9rem' }}>{t("Payer_phone_number")}</h6>
                    <input disabled={!transacData.paymentMethod} value={transacData.payerPhone} onChange={(e) => handleChangepayerPhone(e)} className="form-control" type="number" placeholder="ex : 678 18 75 79" />
                    {!allService.empty(error.payerPhoneErr) && <span className="err">{error.payerPhoneErr}</span>}
                  </div>*/}
                      <button
                        onClick={() => showDownloadPopup(true)}
                        className="btn btn-primary mt-3 mb-3 app-btn"
                        type="button"
                        style={{
                          width: '100%',
                          textTransform: 'uppercase',
                          boxShadow: 'none',
                          borderRadius: 'initial',
                          padding: '15px',
                        }}
                      >
                        <i className="icon-wallet" />
                        <span>{t('Purchase')}</span>
                      </button>

                      {!allService.empty(error.transacErr) && (
                        <span className="err">{error.transacErr}</span>
                      )}
                    </form>
                  )}
                  {showForfait && (
                    <form className="mb-5 w-100">
                      <h3 className="fw-800 title">{t('Buy_mobile_data')}</h3>
                      <div className="mt-4 mb-4">
                        <h6
                          className="text-left"
                          style={{ fontWeight: 300, fontSize: '0.9rem' }}
                        >
                          {t('Number_to_be_credited')}{' '}
                        </h6>
                        <div className="mb-1">
                          <div
                            className="d-inline-block va-t open-list cursor"
                            style={{
                              backgroundColor: 'var(--input-background)',
                              paddingRight: '5px',
                              width: '77px',
                            }}
                          >
                            <div
                              className="d-inline-block"
                              style={{
                                height: '55px',
                                width: '55px',
                                padding: '5px',
                              }}
                            >
                              <img
                                className="img-fluid open-list op-selected d-inline-block"
                                src={
                                  operators.length > 0 ? operators[0].image : ''
                                }
                                ref={dataImageRef}
                              />
                            </div>
                            <i
                              className="icon-arrow-down fl-r fw-600"
                              style={{
                                fontSize: '0.800em',
                                position: 'relative',
                                top: '23px',
                              }}
                            ></i>
                          </div>
                          <div
                            className="drop-lang option-list"
                            style={{
                              width: '255px',
                              marginLeft: '-5px',
                              marginTop: '10px',
                            }}
                          >
                            <h6 style={{ fontSize: '0.865em' }}>
                              {t('choice_of_Operator')}
                            </h6>
                            {operators.map((operator, i) => {
                              if (
                                operator.can_topup === 1 &&
                                operator.bundles_count > 0
                              ) {
                                return (
                                  <a
                                    key={i}
                                    href="#"
                                    onClick={() =>
                                      handleSelectOperatorToCredit(
                                        operator.name,
                                      )
                                    }
                                    className={`choice ${
                                      operator.name ===
                                      transacData.operatorToCredit
                                        ? 'choice-selected'
                                        : ''
                                    } mb-1 elipsis`}
                                  >
                                    <img
                                      src={operator.image}
                                      className="mr-2"
                                      style={{ width: '25px' }}
                                    />
                                    {operator.name}
                                  </a>
                                );
                              }
                            })}
                          </div>
                          <input
                            disabled
                            value={transacData.phoneToCredit}
                            onChange={(e) => handleChangePhoneToCredit(e)}
                            className="form-control d-inline-block"
                            type="number"
                            style={{ width: 'Calc(100% - 86px)' }}
                          />
                        </div>
                        {!allService.empty(error.phoneToCreditErr) && (
                          <span className="err">{error.phoneToCreditErr}</span>
                        )}
                      </div>
                      <div className="form-row">
                        <div className="col">
                          <div className="mb-4 w-100 col-12 p-0">
                            <span
                              onClick={() => showBundlesPopup(!bundlesPopup)}
                              className="fl-r cursor pr"
                              style={{ fontSize: '0.8em', top: '-2px' }}
                            >
                              {t('All_Bundles')}
                            </span>
                            <h6
                              className="text-left"
                              style={{ fontWeight: 300, fontSize: '0.9rem' }}
                            >
                              {t('Choose_a_bundle')}
                            </h6>
                            <div
                              className="d-inline-block select-items"
                              style={{ width: '100%', height: '55px' }}
                            >
                              <button
                                className="btn btn-primary option btn-select open-list"
                                type="button"
                                style={{
                                  height: '100%',
                                  backgroundColor: 'var(--input-background)',
                                }}
                              >
                                &nbsp;
                                <span className="lang mr-2 fl-l fw-600">
                                  {t('Select')}
                                </span>
                                <i className="icon-arrow-down fl-r fw-600" />
                              </button>
                              <div
                                className="drop-lang option-list mt-2"
                                style={{ width: '100%', overflow: 'hidden' }}
                              >
                                <div className="w-100 mb-2">
                                  <input
                                    disabled
                                    onChange={(e) => handleFilter2(e)}
                                    type="text"
                                    placeholder={`Rechercher un forfait ${transacData.operatorToCredit}...`}
                                    autoFocus
                                    className="form-control w-100"
                                    style={{
                                      background: 'var(--input-background)',
                                      height: '40px',
                                      border: 'none',
                                      fontSize: '13px',
                                    }}
                                  />
                                </div>
                                <div
                                  className="of-a"
                                  style={{ maxHeight: '250px' }}
                                >
                                  <a
                                    onClick={() => handleSelectBundle('')}
                                    href="#"
                                    className="choice choice-selected mb-1 elipsis"
                                    data-name="Sélectionner"
                                  >
                                    ---
                                  </a>
                                  {bundles &&
                                    bundles.filter(
                                      (e) =>
                                        e.operator ===
                                        transacData.operatorToCredit,
                                    ) &&
                                    bundles
                                      .filter(
                                        (e) =>
                                          e.operator ===
                                          transacData.operatorToCredit,
                                      )
                                      .map((bundle, i) => {
                                        if (
                                          bundle.active === 1 &&
                                          parseInt(bundle.price) > 0
                                        ) {
                                          return (
                                            <div
                                              onClick={() =>
                                                handleSelectBundle(bundle)
                                              }
                                              key={i}
                                              className="choice read cursor mb-1"
                                              style={{ fontSize: '0.865em' }}
                                              data-name={bundle.name}
                                            >
                                              <span
                                                className="d-block fw-600"
                                                style={{ fontSize: '1.2em' }}
                                              >
                                                {bundle.name}
                                              </span>
                                              <span
                                                className="elipsis d-block"
                                                style={{ fontSize: '0.865em' }}
                                              >
                                                {bundle.description}
                                              </span>
                                            </div>
                                          );
                                        }
                                      })}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="mb-4">
                        <h6
                          className="mb-0"
                          style={{
                            fontWeight: 300,
                            fontSize: '0.9rem',
                            lineHeight: 1,
                          }}
                        >
                          {t('payment_mode')}
                        </h6>
                        <span
                          className="font-weight-light"
                          style={{ fontSize: '0.8em' }}
                        >
                          {t('payment_is_secured_and_without_charges')}
                        </span>
                        <div className="mt-2 mb-2">
                          <div
                            className="d-inline-block va-t open-list cursor"
                            style={{
                              backgroundColor: 'var(--input-background)',
                              paddingRight: '5px',
                              width: '77px',
                            }}
                          >
                            <div
                              className="d-inline-block"
                              style={{
                                width: '55px',
                                height: '55px',
                                padding: '5px',
                              }}
                            >
                              <img
                                className="img-fluid open-list op-selected d-inline-block"
                                src={
                                  paymentMethods.find(
                                    (e) => e.code === transacData.paymentMethod,
                                  ).logo
                                }
                              />
                            </div>
                            <i
                              className="icon-arrow-down fl-r fw-600"
                              style={{
                                fontSize: '0.800em',
                                position: 'relative',
                                top: '23px',
                              }}
                            ></i>
                          </div>
                          <div
                            className="drop-lang option-list"
                            style={{ width: '255px', marginTop: '10px' }}
                          >
                            <h6 style={{ fontSize: '0.865em' }}>
                              {t('choice_of_Operator')}
                            </h6>
                            {paymentMethods.map((paymentMethod, i) => {
                              return (
                                <a
                                  key={i}
                                  href="#"
                                  onClick={() =>
                                    handleSelectPaymentMethod(
                                      paymentMethod.code,
                                      paymentMethod.logo,
                                    )
                                  }
                                  className={`choice ${
                                    paymentMethod.code ===
                                    transacData.paymentMethod
                                      ? 'choice-selected'
                                      : ''
                                  } mb-1 elipsis`}
                                >
                                  <img
                                    src={paymentMethod.logo}
                                    className="mr-2"
                                    style={{ width: '25px' }}
                                  />
                                  {paymentMethod.name}
                                </a>
                              );
                            })}
                          </div>
                          <input
                            disabled
                            value={transacData.payerPhone}
                            onChange={(e) => handleChangepayerPhone(e)}
                            className="form-control form-with-logo d-inline-block"
                            type="number"
                            style={{
                              width: 'Calc(100% - 77px)',
                              border: 'none',
                            }}
                            placeholder={`Numéro ${
                              paymentMethods.find(
                                (e) => e.code === transacData.paymentMethod,
                              ).name
                            }`}
                          />
                        </div>
                        {!allService.empty(error.payerPhoneErr) && (
                          <span className="err">{error.payerPhoneErr}</span>
                        )}
                      </div>
                      <div
                        className="mb-2 fw-300"
                        style={{ height: '25px', fontSize: '0.9rem' }}
                      >
                        <span className="fl-l fw-300">
                          {t('Bundle_cost')} :&nbsp;
                        </span>
                        <span className="fl-r">
                          {transacData.bundleChoice.price
                            ? allService.numberWithCommas(
                                transacData.bundleChoice.price,
                              )
                            : 0}{' '}
                          Fcfa
                        </span>
                      </div>
                      <div
                        className="mb-2 fw-300"
                        style={{ height: '25px', fontSize: '0.9rem' }}
                      >
                        <span className="fl-l fw-300">
                          {t('Charges_and_taxes')} :&nbsp;
                        </span>
                        <span className="fl-r">0 Fcfa</span>
                      </div>
                      <div className="mb-3" style={{ height: '25px' }}>
                        <h5 className="fl-l fw-700 title1 d-none d-md-block">
                          {t('Total_to_be_paid')}
                        </h5>
                        <h5 className="fl-l fw-700 title1 d-md-none">Total</h5>
                        <h5 className="fl-r fw-700 title1">
                          {transacData.bundleChoice.price
                            ? allService.numberWithCommas(
                                transacData.bundleChoice.price,
                              )
                            : 0}{' '}
                          Fcfa
                        </h5>
                      </div>
                      <button
                        onClick={() => showDownloadPopup(true)}
                        className="btn btn-primary mt-3 mb-3 app-btn"
                        type="button"
                        style={{
                          width: '100%',
                          textTransform: 'uppercase',
                          boxShadow: 'none',
                          borderRadius: 'initial',
                          padding: '15px',
                        }}
                      >
                        {!loadTransac && (
                          <i className="icon-wallet" style={{ top: '1px' }} />
                        )}
                        {loadTransac && (
                          <i
                            className="fa fa-circle-o-notch fa-spin speed-spin mr-2"
                            style={{ top: '1px' }}
                          ></i>
                        )}
                        &nbsp; <span>{t('Purchase')}</span>
                      </button>
                      {!allService.empty(error.transacErr) && (
                        <span className="err">{error.transacErr}</span>
                      )}
                    </form>
                  )}
                </div>
                <span
                  className="fw-100 second-txt-color mt-4"
                  style={{
                    color: '#A6ACAF',
                    fontWeight: 100,
                    fontSize: '0.865em',
                  }}
                >
                  <i className="fa fa-copyright fw-100" />
                  &nbsp;<span style={{ fontSize: '13.5px' }}>2022</span>&nbsp;
                  <strong>Glotelho Pay&nbsp;</strong>
                  <span
                    className="lang fw-100 second-txt-color"
                    keyword="all-rights-reserved"
                  >
                    {t('All_rights_reserved')}
                  </span>
                  .
                </span>
              </div>
            </div>
          </div>
        </div>
      )}

      {showTransaction && !userLoader && !pageErr && (
        <div
          className="row col-12 col-lg-8 col-xl-7 m-auto p-0"
          style={{ zIndex: 1 }}
        >
          <div className="col col-12 p-0">
            <div
              className="content text-left col-12"
              style={{
                position: 'relative',
                background: 'inherit',
                zIndex: 2000,
              }}
            >
              <div className="container p-0">
                <div className="display" style={{ display: 'block' }}>
                  {allTransac.length > 0 && (
                    <div className="w-100">
                      <div className="d-inline-block">
                        <h3 className="fw-900 mb-0">
                          <i
                            className="icon ion-arrow-left-c cursor mr-2"
                            onClick={() => setShowTransaction(false)}
                          ></i>
                        </h3>
                      </div>
                      <div
                        className="d-inline-block va-t"
                        style={{ width: '80%' }}
                      >
                        <h3 className="fw-900 mb-0 title">
                          {t('My_transactions')}
                        </h3>
                        <span className="d-block mb-3">
                          {count} transaction(s) total
                        </span>
                      </div>
                    </div>
                  )}
                  {(allTransac.length > 0 ||
                    paginatedData.length > 0 ||
                    filteredAllData.length > 0) && (
                    <div className="col p-0 col-12" style={{ height: '100%' }}>
                      <div
                        className="table-content pt-0"
                        style={{ height: '100%' }}
                      >
                        <div style={{ height: '60px' }}>
                          <form
                            className="search app-color d-inline-block"
                            style={{
                              display: 'block',
                              background: '#fff',
                              verticalAlign: 'top',
                              height: '45px',
                              width: '100%',
                            }}
                          >
                            <div
                              style={{
                                display: 'inline-block',
                                width: '100%',
                                boxShadow:
                                  '0 10px 20px -8px rgba(0, 0, 0, 0.24)',
                              }}
                            >
                              <div
                                className="d-none d-md-inline-block"
                                style={{
                                  textAlign: 'center',
                                  width: '50px',
                                  position: 'relative',
                                  height: '45px',
                                  padding: '7px',
                                  paddingTop: '10px',
                                }}
                              >
                                <i
                                  className="icon-magnifier"
                                  style={{ fontSize: '1.6em' }}
                                />
                              </div>
                              <input
                                disabled
                                name="clear"
                                value={clear}
                                className="form-control"
                                type="text"
                                onChange={(e) => handleFilter(e)}
                                placeholder={t('Search_a_transaction')}
                                autoFocus
                                style={{
                                  background: 'inherit',
                                  color: 'inherit',
                                  borderRadius: 0,
                                  height: '45px',
                                  display: 'inline-block',
                                  width: '40%',
                                  border: 'NONE',
                                  verticalAlign: 'top',
                                  boxShadow: 'none',
                                  fontSize: '13px',
                                }}
                              />
                              <div
                                style={{
                                  float: 'right',
                                  display: 'inline-block',
                                  position: 'relative',
                                  right: '7px',
                                  width: '40%',
                                }}
                              >
                                <div
                                  className="d-inline-block mt-1 select-items"
                                  style={{ width: '100%', height: '38px' }}
                                >
                                  <button
                                    className="btn btn-primary option btn-select open-list bg-i"
                                    type="button"
                                    style={{
                                      height: '100%',
                                      background: 'inherit',
                                    }}
                                  >
                                    <span className="lang mr-2 fl-l fw-600">
                                      {t('Show_all')}
                                    </span>
                                    <i className="icon-arrow-down fl-r fw-600" />
                                  </button>
                                  <div
                                    className="drop-lang option-list mt-2"
                                    style={{ width: '100%' }}
                                  >
                                    <h6
                                      className="elipsis"
                                      style={{ fontSize: '0.9em' }}
                                    >
                                      {t('Filter_by_status')}
                                    </h6>
                                    {TransactionStatus.slice(
                                      0,
                                      TransactionStatus.length - 1,
                                    ).map((status, index) => {
                                      return (
                                        <a
                                          key={index}
                                          className="choice choice1 mb-1 elipsis"
                                          onClick={() =>
                                            handleStatus(status.value)
                                          }
                                          data-id={index}
                                          data-name={status.label}
                                        >
                                          {status.label}
                                        </a>
                                      );
                                    })}
                                    <a
                                      onClick={() => handleStatus('all')}
                                      className="choice choice-selected mb-1 elipsis"
                                      data-id={
                                        TransactionStatus[
                                          TransactionStatus.length - 1
                                        ].value
                                      }
                                      data-name={
                                        TransactionStatus[
                                          TransactionStatus.length - 1
                                        ].label
                                      }
                                    >
                                      {
                                        TransactionStatus[
                                          TransactionStatus.length - 1
                                        ].label
                                      }
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </form>

                          {/*<div className="mt-3" style={{ width: '100%', height: '50px' }}>
                          <button onClick={() => setShowTransaction(false)} className="btn btn-primary app-btn add-collection fl-r" type="button" style={{ textTransform: 'none', fontSize: '0.885em', fontWeight: 400, padding: '.3rem .75rem'}}><i className="icon ion-plus" />&nbsp;&nbsp;<span className="lang">Nouvelle
                            recharge</span>
                          </button>
                        </div>*/}
                        </div>
                        <div
                          className="mb-2"
                          style={{
                            height: '60px',
                            background: '#fff',
                            padding: '10px 10px',
                          }}
                        >
                          <div
                            className="col col-8 col-xl-6 col-lg-6"
                            style={{ float: 'left', padding: 0 }}
                          >
                            <div className="input">
                              <div
                                className="d-inline-block mt-1 select-items"
                                style={{ width: '100%', height: '38px' }}
                              >
                                <button
                                  className="btn btn-primary option btn-select open-list option-list2 bg-i"
                                  type="button"
                                  style={{
                                    height: '100%',
                                    background: 'inherit!important',
                                  }}
                                >
                                  &nbsp;
                                  <span className="lang mr-2 fl-l fw-600">
                                    {TransactionCount[0].label}
                                  </span>
                                  <i className="icon-arrow-down fl-r fw-600" />
                                </button>
                                <div
                                  className="drop-lang option-list mt-2"
                                  style={{ width: '100%' }}
                                >
                                  <a
                                    className="choice mb-1 elipsis choice-selected"
                                    onClick={() => handleNumberFilter(1)}
                                    data-id={TransactionCount[0].value}
                                    data-name={TransactionCount[0].label}
                                  >
                                    {TransactionCount[0].label}
                                  </a>
                                  {TransactionCount.slice(1).map(
                                    (collection, index) => {
                                      return (
                                        <a
                                          key={index}
                                          className="choice mb-1 elipsis"
                                          onClick={() =>
                                            handleNumberFilter(collection.value)
                                          }
                                          data-id={index}
                                          data-name={collection.label}
                                        >
                                          {collection.label}
                                        </a>
                                      );
                                    },
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="col col-6 d-none d-sm-block"
                            style={{
                              float: 'right',
                              position: 'relative',
                              top: '13px',
                            }}
                          >
                            <span
                              className="row_count_warehouse"
                              style={{ float: 'right' }}
                            >
                              {t('From')} {paginatedData.length > 0 ? 1 : 0}{' '}
                              {t('to')} {paginatedData.length} {t('out_of')}{' '}
                              {allTransac.length}
                            </span>
                          </div>
                        </div>
                        <div
                          className="mb-4"
                          style={{
                            background: '#fff',
                            minHeight: '400px',
                            padding: '15px 10px',
                          }}
                        >
                          <div
                            style={{
                              minHeight: '380px',
                              maxHeight: '500px',
                              overflow: 'auto',
                            }}
                          >
                            <table className="table table-warehouse">
                              <thead>
                                <tr
                                  style={{
                                    borderTop: 'hidden',
                                    borderBottom: 'hidden',
                                  }}
                                >
                                  <th className="lang" width="90px">
                                    #
                                  </th>
                                  <th className="lang" width="150px">
                                    {t('Transaction_Type')}
                                  </th>
                                  <th className="lang" width="95px">
                                    {t('Status')}
                                  </th>
                                  <th className="lang text-left" width="130px">
                                    {t('Number_to_be_credited')}
                                  </th>
                                  <th className="lang" width="140px">
                                    {t('Payer_number')}
                                  </th>
                                  <th className="lang" width="110px">
                                    {t('Amount')}
                                  </th>
                                  <th className="lang" width="200px">
                                    {t('Bundle')}
                                  </th>
                                  <th className="lang" width="210px">
                                    {t('Transaction_date')}
                                  </th>
                                </tr>
                              </thead>
                              <tbody id="warehousecontent">
                                {paginatedData.map((d, index) => {
                                  return (
                                    <tr
                                      key={index}
                                      style={{ borderTop: 'hidden' }}
                                      className="read"
                                    >
                                      <td className="elipsis">{d.uuid}</td>
                                      <td className="elipsis">
                                        {d.type === 'TOPUP'
                                          ? t('Purchase_Credit')
                                          : t('Purchase_Bundle')}
                                      </td>
                                      {d.status === 'NEW' && (
                                        <td>
                                          <div
                                            className="new fw-500"
                                            style={{
                                              fontSize: '0.824em',
                                              textAlign: 'center',
                                            }}
                                          >
                                            {t('New')}
                                          </div>
                                        </td>
                                      )}
                                      {d.status === 'PENDING' && (
                                        <td>
                                          <div
                                            className="in-progress fw-500"
                                            style={{
                                              fontSize: '0.824em',
                                              textAlign: 'center',
                                            }}
                                          >
                                            {t('In_progress')}
                                          </div>
                                        </td>
                                      )}
                                      {d.status === 'COMPLETED' && (
                                        <td>
                                          <div
                                            className="active fw-500"
                                            style={{
                                              fontSize: '0.824em',
                                              textAlign: 'center',
                                            }}
                                          >
                                            {t('Completed')}
                                          </div>
                                        </td>
                                      )}
                                      {d.status === 'FAILED' && (
                                        <td>
                                          <div
                                            className="canceled fw-500"
                                            style={{
                                              fontSize: '0.824em',
                                              textAlign: 'center',
                                            }}
                                          >
                                            {t('Failed')}
                                          </div>
                                        </td>
                                      )}
                                      <td>
                                        {allService.chunk(
                                          d.receiver_number,
                                          3,
                                          ' ',
                                        )}
                                      </td>
                                      <td className="elipsis">
                                        {d.payer_number
                                          ? allService.chunk(
                                              d.payer_number,
                                              3,
                                              ' ',
                                            )
                                          : ''}
                                      </td>
                                      <td className="elipsis">
                                        {allService.numberWithCommas(d.amount)}{' '}
                                        Fcfa
                                      </td>
                                      <td>
                                        {d.bundle_name
                                          ? d.bundle_name
                                          : t('Not_defined')}
                                      </td>
                                      <td>
                                        {d.created_at &&
                                          new Date(
                                            d.created_at,
                                          ).toLocaleDateString('fr-FR', {
                                            weekday: 'long',
                                            year: 'numeric',
                                            month: 'long',
                                            day: 'numeric',
                                          })}
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                          <Pagination
                            currentPage={currentPage}
                            pages={pages}
                            goToPreviousPage={goToPreviousPage}
                            goToNextPage={goToNextPage}
                            pagination={pagination}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                  {allTransac.length === 0 && (
                    <div id="transac-empty" className="text-center mt-4">
                      <div
                        className="d-inline-block mb-3 empty-block p-4 rounded-circle"
                        style={{ background: 'rgba(242, 243, 244, 1)' }}
                      >
                        <img
                          src="assets/img/icons8_transaction_approved_125px.png"
                          className="pr"
                          style={{ width: '100px', left: '3px' }}
                        />
                      </div>
                      <h5 className="mb-1">
                        <strong>{t('No_transactions')}</strong>
                      </h5>
                      {!isAuthenticated && (
                        <p>
                          {t('Dont_lose_transactions')}{' '}
                          <strong>{t('log_in')}</strong> {t('device_access')}
                        </p>
                      )}
                      {isAuthenticated && (
                        <p className="m-auto" style={{ maxWidth: '400px' }}>
                          {t('pay_for_services')}
                        </p>
                      )}
                      <div className="row col-12 col-lg-7 m-auto p-0">
                        {!isAuthenticated && (
                          <div className="col col-6">
                            <button
                              onClick={() => navigation('/login')}
                              className="btn btn-primary mt-3 mb-2 btn-opt"
                              type="submit"
                              style={{
                                width: '100%',
                                boxShadow: 'none',
                                borderRadius: 'initial',
                                padding: '16px',
                              }}
                            >
                              <i className="icon-lock-open" />
                              &nbsp;{' '}
                              <span>
                                {t('login')}
                                <br />
                              </span>
                            </button>
                          </div>
                        )}
                        <div
                          className={`col ${
                            isAuthenticated ? 'col-12 col-sm-6' : 'col-6'
                          } m-auto`}
                        >
                          <button
                            onClick={() => setShowTransaction(false)}
                            className="btn btn-primary mt-3 mb-2 app-btn"
                            type="submit"
                            style={{
                              width: '100%',
                              boxShadow: 'none',
                              borderRadius: 'initial',
                              padding: '15px',
                            }}
                          >
                            <i className="icon-wallet" />
                            &nbsp; <span>{t('recharger')}</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                  {(allTransac.length > 0 ||
                    paginatedData.length > 0 ||
                    filteredAllData.length > 0) && (
                    <span
                      className="fw-100 second-txt-color d-block mb-2"
                      style={{
                        color: '#A6ACAF',
                        fontWeight: 100,
                        fontSize: '0.865em',
                      }}
                    >
                      <i className="fa fa-copyright fw-100" />
                      &nbsp;<span>2022</span>&nbsp;
                      <strong>Glotelho Pay&nbsp;</strong>
                      <span className="lang fw-100 second-txt-color">
                        {t('All_rights_reserved')}
                      </span>
                      .
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {pageErr && (
        <div
          className="row col-12 col-lg-7 col-xl-6 m-auto p-0"
          style={{ zIndex: '1' }}
        >
          <div className="col col-12 p-0">
            <div
              className="content text-left col-12"
              style={{ background: 'inherit', zIndex: '2000' }}
            >
              <div className="container text-center mt-4">
                <div
                  className="d-inline-block mb-3 empty-block p-4 rounded-circle"
                  style={{ background: 'rgba(242, 243, 244, 1)' }}
                >
                  <img
                    src="assets/img/icons8_error_cloud_125px.png"
                    className="pr"
                    style={{ left: '3px', width: '80px' }}
                  />
                </div>
                <h5 className="mb-1">
                  <strong>Oups! Une erreur est survenue</strong>
                </h5>
                <p>
                  Une erreur est survenue lors de la récupération des données de
                  transactions. Veuillez svp <strong>actualiser</strong> la page
                  pour réessayer.
                </p>
                <div className="row col-12 col-lg-7 m-auto p-0">
                  <div className="col col-12 col-md-6 m-auto">
                    <button
                      onClick={() => {
                        window.location.reload();
                      }}
                      className="btn btn-primary mt-2 mb-2 app-btn w-100"
                      style={{
                        boxShadow: 'none',
                        borderRadius: 'initial',
                        padding: '15px',
                      }}
                    >
                      <i className="icon-refresh mr-2"></i>
                      <span>
                        Actualiser
                        <br />
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/**Modal to add or edit user*/}
      <Toaster toastOptions={{ position: 'bottom-center' }} />

      {showNewTransaction && (
        <NewTransaction
          showNewTransaction={showNewTransaction}
          setShowNewTransaction={setShowNewTransaction}
          transacData={transacData}
          avortTransac={avortTransac}
        />
      )}

      <Faq showFaq={showFaq} setShowFaq={setShowFaq} />

      <div className="modal modal-bundles">
        <div
          id="modal-bundles"
          className="modal-content of-a"
          style={{ height: '97%', padding: '10px 0' }}
        >
          <div className="text-right" style={{ padding: '0 30px' }}>
            <i
              onClick={() => showBundlesPopup(!bundlesPopup)}
              className="icon ion-android-close close fl-r cursor pr"
              id="close-user-edit"
              style={{
                color: 'inherit',
                fontWeight: 'bold',
                top: '0px',
                left: '20px',
              }}
            ></i>
          </div>
          <div style={{ border: 'none', padding: '0 25px' }}>
            <h3 className="fw-700 mb-0">{t('All_Bundles')}</h3>
            <span className="pr" style={{ fontSize: '0.85em', top: '-3px' }}>
              {bundles.length} {t('Bundle')}(s) total
            </span>
            <form
              className="search col-12 col-md-8 col-lg-12 p-0 mt-2 mb-2"
              style={{ background: '#fff', height: '45px' }}
            >
              <div
                className="w-100"
                style={{ boxShadow: '0 10px 20px -8px rgba(0, 0, 0, 0.24)' }}
              >
                <div
                  className="d-none d-md-inline-block text-center pr col-0 col-md-1"
                  style={{ height: '45px', padding: '7px', paddingTop: '10px' }}
                >
                  <i
                    className="icon-magnifier pr"
                    style={{ fontSize: '1.4em', top: '4px' }}
                  ></i>
                </div>
                <input
                  disabled
                  onChange={(e) => handleFilter1(e)}
                  type="text"
                  placeholder={t('Search_a_bundle')}
                  autoFocus
                  className="form-control bg-i d-inline-block col-6 col-md-6"
                  style={{
                    color: 'inherit',
                    borderRadius: '0',
                    height: '45px',
                    border: 'NONE',
                    verticalAlign: 'top',
                    boxShadow: 'none',
                    fontSize: '12px',
                  }}
                />
                <div
                  className="col-6 col-md-5 p-0 fl-r pr d-inline-block"
                  style={{ right: '7px' }}
                >
                  <div
                    className="d-inline-block mt-1 select-items w-100"
                    style={{ height: '38px' }}
                  >
                    <button
                      className="btn btn-primary option btn-select open-list h-100 bg-i"
                      type="button"
                    >
                      <span className="lang mr-2 fl-l fw-600">
                        {t('Show_all')}
                      </span>
                      <i className="icon-arrow-down fl-r fw-600"></i>
                    </button>
                    <div className="drop-lang option-list mt-2 w-100">
                      <h6
                        className="elipsis"
                        title="Filtrer par catégorie"
                        style={{ fontSize: '0.9em' }}
                      >
                        {t('Filter_by_operator')}
                      </h6>
                      {operatorStatus
                        .slice(0, operatorStatus.length - 1)
                        .map((status, index) => {
                          return (
                            <a
                              key={index}
                              className="choice choice1 mb-1 elipsis"
                              onClick={() => handleStatus1(status.value)}
                              data-id={index}
                              data-name={status.label}
                            >
                              {status.label}
                            </a>
                          );
                        })}
                      <a
                        onClick={() => handleStatus1('all')}
                        href="#"
                        className="choice choice-selected mb-1 elipsis"
                        data-id={2}
                        data-name="Tout affiché"
                      >
                        {t('Show_all')}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div
            className="display of-a"
            style={{ display: 'block', padding: '0 25px' }}
          >
            <table className="table">
              <thead>
                <tr style={{ borderTop: 'hidden', borderBottom: 'hidden' }}>
                  <th className="lang"></th>
                  <th
                    className="lang text-right d-none d-md-block"
                    width="120px"
                  ></th>
                </tr>
                {bundles.length === 0 && (
                  <tr
                    className="warning no-result-warehous"
                    style={{ borderTop: 'hidden' }}
                  >
                    <td colSpan="2">
                      <i className="fa fa-warning"></i>
                      <span className="lang"> {t('No_result')}</span>
                    </td>
                  </tr>
                )}
              </thead>
              <tbody id="warehousecontent">
                {bundles &&
                  bundles.map((bundle, id) => {
                    return (
                      <tr
                        key={id}
                        style={{ borderTop: 'hidden' }}
                        className="read"
                      >
                        <td>
                          {/*<img src={operators.find(e => e.name === bundle.operator).image} className="d-inline-block va-t pr mr-2 paiement-logo pr" style={{width:"18px", top:"7px"}} />*/}
                          <div
                            className="d-inline-block va-t pr"
                            style={{ width: 'Calc(100% - 26px)' }}
                          >
                            <span
                              className="fw-300"
                              style={{ fontSize: '0.85em' }}
                            >
                              {bundle.name}
                            </span>
                            <p
                              className="mb-0 pr fw-500"
                              style={{ fontSize: '0.95em', top: '-4px' }}
                            >
                              {bundle.description}
                            </p>
                            <span
                              className="fw-300 d-block d-md-none fw-400"
                              style={{ fontSize: '0.85em' }}
                            >
                              {allService.numberWithCommas(bundle.price)} Fcfa
                            </span>
                          </div>
                        </td>
                        <td
                          style={{ fontSize: '0.9em' }}
                          className="elipsis text-right d-none d-md-block"
                        >
                          {allService.numberWithCommas(bundle.price)} Fcfa
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div className="modal modal-download" style={{ paddingTop: '100px' }}>
        <div
          id="modal-download"
          className="modal-content"
          style={{ overflow: 'auto', width: '45%' }}
        >
          <div>
            <i
              id="close-user-edit"
              className="icon ion-android-close close"
              onClick={() => showDownloadPopup(!downloadPopup)}
              style={{
                color: 'inherit',
                float: 'right',
                fontWeight: 'bold',
                cursor: 'pointer',
                position: 'relative',
                top: '0px',
                left: '20px',
              }}
            ></i>
          </div>
          <div className="display text-left" style={{ display: 'block' }}>
            <div
              className="mt-2 text-center"
              style={{ border: 'none', padding: '0', fontSize: '1.4em' }}
            >
              <div className="row">
                <div className="col">
                  <h4 className="fw-900 text-uppercase title1">
                    {t('download_header')}
                  </h4>
                </div>
              </div>
              <span className="d-block mb-3" style={{ fontSize: '0.7em' }}>
                {t('download_msg')}
              </span>
              <div className="col col-12 col-lg-8 m-auto">
                <div className="row">
                  <div className="col p-0 pr-1">
                    <a
                      href="https://play.google.com/store/apps/details?id=cm.glotelho.glotelho_pay"
                      target="_blank"
                    >
                      <img className="img-fluid" src="assets/img/google.png" />
                    </a>
                  </div>
                  <div className="col p-0 pl-1">
                    <a
                      href="https://apps.apple.com/be/app/glotelho-pay/id1660530553"
                      target="_blank"
                    >
                      <img className="img-fluid" src="assets/img/apple.png" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {transacSuccessMsg && (
        <div
          className="modal modal-transac-done display"
          style={{ display: `${transacSuccessMsg ? 'block' : 'none'}` }}
        >
          <div
            className="modal-content col-11 col-xl-4 col-lg-5 col-md-8"
            style={{ padding: '0' }}
          >
            <div className="container text-center">
              <div
                className="col"
                style={{ padding: '40px 25px', paddingTop: '25px' }}
              >
                <div>
                  <img
                    src="assets/img/check-circle.gif"
                    className="img-fluid"
                    style={{ width: '140px' }}
                  />
                  <div className="mt-2">
                    <h5>
                      <strong>{t('Transaction_done')} !</strong>
                    </h5>
                    <span className="d-block mb-3" style={{ fontSize: '15px' }}>
                      {t('Do_not_lose')} {t('history_of_your_transactions')}{' '}
                      <strong>{t('log_in')}</strong>{' '}
                      {t('To_have_on_all_devices')}
                    </span>
                  </div>
                  <div>
                    <a
                      onClick={() => navigation('/login')}
                      className="btn btn-primary app-btn mb-3"
                      role="button"
                      href="#"
                      style={{ borderRadius: 'initial', padding: '15px' }}
                    >
                      {t('login')}
                    </a>
                  </div>
                  <p
                    className="mb-0 cursor close-modal-basket btn-close-form"
                    style={{ textDecoration: 'underline' }}
                  >
                    {t('Later')}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
